module.exports = __webpack_public_path__ + "static/media/autocomplete_icon.ed3cbd09.svg";